module.exports = __webpack_public_path__ + "img/Z60Q_05.23a4b55b.jpg";